import { useQuery, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { AccountOpeningDraftDTO, AccountStatus, DraftAccountDTO } from '../AccountOpening.meta';

const fetchDraftAccount = async (
  clientId: string,
  draftId: string,
): Promise<AccountOpeningDraftDTO> => {
  return authFetch(
    urlWithParams('/Consumer/ManagedAccounts/AccountOpeningDraft', { clientId, id: draftId }),
  );
};

interface QueryParams {
  clientId: string;
  draftId: string;
}

export const useDraftAccountQuery = ({ clientId, draftId }: QueryParams) => {
  return useQuery(
    queryKeys.draftAccount(clientId, draftId),

    () => fetchDraftAccount(clientId, draftId),

    {
      cacheTime: 0,
    },
  );
};

export const useDraftAccountCache = () => {
  const queryClient = useQueryClient();

  const { clientId, draftId } = useRouteParams();

  const queryKey = queryKeys.draftAccount(clientId, draftId);

  const mutateDraftAccount = (data: Partial<DraftAccountDTO>) => {
    queryClient.setQueryData<AccountOpeningDraftDTO | undefined>(queryKey, cache => {
      if (!cache) {
        return cache;
      }

      return {
        ...cache,
        data: {
          ...cache.data,
          ...data,
        },
      };
    });
  };

  const mutateAccountStatus = (status: AccountStatus) => {
    queryClient.setQueryData<AccountOpeningDraftDTO | undefined>(queryKey, cache => {
      if (!cache) {
        return cache;
      }

      return {
        ...cache,
        accountOpeningStatus: status,
      };
    });
  };

  return {
    mutateDraftAccount,
    mutateAccountStatus,
  };
};
